import { Box, Flex, ListItem, Text } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { useColorMode } from '../common/color-mode';

interface GameInfoItemProps {
	icon: IconType;
	label: string;
	value: string | number;
}

const GameInfoItem = ({ icon, label, value }: GameInfoItemProps) => {
	const { colorMode } = useColorMode();

	return (
		<ListItem
			color={colorMode}
			display="flex"
			alignItems="center"
			justifyContent="space-between"
			flexWrap="wrap"
		>
			<Flex alignItems="center">
				<Box as={icon} fontSize="20px" mr="2" />
				<Text
					textTransform="uppercase"
					fontWeight="600"
					letterSpacing="wider"
					mr="3"
				>
					{label}:
				</Text>
			</Flex>
			<Text fontWeight="400">{value}</Text>
		</ListItem>
	);
};

export default GameInfoItem;
